import type * as FirebaseAuth from "firebase/auth"
import { useState } from "react"
import { useForm } from "react-hook-form"
import { api } from "../../core"
import { Navigate } from "react-router-dom"
import { Paths } from "../../paths"


type VirtualCastOAuthAccessTokenForms = {
  redirect_uri: string
}

export const VirtualCastOAuthAccessTokenForm = (props: { firebase: FirebaseAuth.User; code: string; state: string }) => {
  const form = useForm<VirtualCastOAuthAccessTokenForms>({
    mode: "onBlur",
    defaultValues: {
      redirect_uri: "http://localhost:3001/oauth/virtualcast/callback",
    },
  })
  const [done, setDone] = useState<boolean>(false)
  if (done) {
    return <Navigate to={Paths.my.path} />
  }

  const onSubmit = async () => {
    try {
      const idToken = await props.firebase.getIdToken()
      const response = await api.POST("/api/v2/users/me/oauth/virtualcast/access-token", {
        headers: {
          authorization: `Bearer ${idToken}`,
        },
        body: {
          code: props.code,
          state: props.state,
        },
      })
      if (response.data === undefined) {
        console.error(`invalid response: ${JSON.stringify(response.error)}`)
        return
      }
      setDone(true)
    } catch (e) {
      console.error(e)
    }
  }

  const { isSubmitting, isValid } = form.formState

  return (
    <>
      <form className="d-flex w-100 flex-column gap-3" onSubmit={form.handleSubmit(onSubmit)}>
        <button type="submit" className="btn btn-primary form-control" disabled={isSubmitting || !isValid}>
          Generate Access Token
        </button>
      </form>
    </>
  )
}
